import AgencyHelper from 'features/Agency/agencyHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import DashboardChartCard from 'general/components/quybka/Cards/DashboardChartCard';
import BarChart from 'general/components/quybka/Charts/BarChart';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import AgencyDashboardHeaderView from '../../components/AgencyDashboardHeaderView';
import useAppConfig from 'hooks/useAppConfig';
import { useSelector } from 'react-redux';
import DoughnutChartJS from 'general/components/quybka/Charts/DoughnutChartJS';

VoucherPartnerDashboardScreen.propTypes = {
  agencyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function VoucherPartnerDashboardScreen({ agencyId, ...props }) {
  // MARK: ---- PROPERTIES ----
  const { user } = useSelector((state) => state.auth);
  const appConfig = useAppConfig();

  const [chartData, setChartData] = useState({});
  const [chartFilter, setChartFilter] = useState({
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.baMuoiNgayGanNhat,
  });
  useEffect(() => {
    ChargeHelper.API.Dashboard.requestGetDailyData({
      from: chartFilter.from,
      to: chartFilter.to,
    }).then((res) => {
      setChartData(res ?? {});
    });
  }, [chartFilter]);

  // thong tin dau tu
  const [voucherPartnerReportData, setVoucherPartnerReportData] = useState({});
  useEffect(() => {
    AgencyHelper.API.requestGetVoucherPartnerDashboard({}).then((response) => {
      console.log({ response });
      setVoucherPartnerReportData(response);
    });
  }, []);

  // so luot su dung voucher theo ngay
  const voucherUsedByDateEl = useMemo(() => {
    const voucherByDate = voucherPartnerReportData?.usageByDay ?? [];
    let labels = voucherByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = voucherByDate?.map((item) => item.usageCount ?? 0);

    if (voucherByDate?.length > 31) {
      const groupedData = _.groupBy(voucherByDate, (item) =>
        moment(item.date).format('MM/YYYY')
      );
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.usageCount, 0);
        return total;
      });
    }

    return (
      <DashboardChartCard
        title="Số lượt sử dụng voucher của KH"
        name="Tổng"
        value={
          Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' lượt'
        }
        valueColor="rgba(48, 189, 111, 1)"
        actionEl={
          <CustomDateRangePicker
            alignRight={true}
            toggleFontWeight="600"
            toggleElementBorderRadius={10}
            initialValue={chartFilter.selectedValue}
            onPressSave={(selectedValue, startDate, endDate) => {
              setChartFilter({
                from: startDate,
                to: endDate,
                selectedValue: selectedValue,
              });
            }}
          />
        }
        chartEl={
          <BarChart
            title="Lượt"
            unit="lượt"
            labels={labels}
            data={data}
            color="rgba(48, 189, 111, 0.4)"
            hoverColor="rgba(48, 189, 111, 1)"
          />
        }
      />
    );
  }, [chartData, chartFilter]);

  // MARK: ---- METHODS ----

  return (
    <div className="mt-4" style={{ minHeight: '1200px' }}>
      {/* header */}
      <div className="px-4">
        <AgencyDashboardHeaderView
          name={user?.agency?.name}
          role="Đối tác mua voucher"
          contentEl={
            <div className="px-4 d-flex flex-column gap-3 mt-4">
              {UIHelper.buildStatisticItem(
                'rgba(88, 183, 198, 1)',
                <div className="d-flex align-items-center gap-2">Số voucher đã phát hành trong tháng</div>,
                `${Utils.formatNumber(voucherPartnerReportData?.releasedVouchers ?? 0)} voucher`,
                null,
                'fa-solid fa-ticket'
              )}
              {appConfig.showShareRatio ? UIHelper.buildStatisticItem(
                'rgba(48, 189, 111, 1)',
                <div className="d-flex align-items-center gap-2">
                  Tổng giá trị voucher đã phát hành trong tháng
                </div>,
                `${Utils.formatNumber(voucherPartnerReportData?.releasedValue ?? 0)} VNĐ`,
                null,
                'fa-solid fa-chart-mixed'
              ) : <></>}
              {UIHelper.buildStatisticItem(
                'rgba(255, 166, 63, 1)',
                <div className="d-flex align-items-center gap-2">
                  Tổng voucher còn hiệu lực
                </div>,
                `${Utils.formatNumber(voucherPartnerReportData?.validVouchers ?? 0)} voucher`,
                null,
                'fa-solid fa-check-circle'
              )}
            </div>
          }
        />
      </div>

      {/* bieu do */}
      <div className="mt-4">
        <div className="row m-0 p-0 px-2">
          {/* so luot su dung voucher theo ngay */}
          <div className="col-lg-6 px-2 mb-4">{voucherUsedByDateEl}</div>
          {/* so luong xe va khach hang */}
          <div className="col-lg-6 mb-4 px-2">
            {UIHelper.buildCard(
              <div>
                {UIHelper.buildCardHeader('Số lượng xe và khách hàng', false, null, false, true)}
                <div className="px-4 pb-4 d-flex align-items-center gap-3">
                  <div
                    className=""
                    style={{
                      height: '200px',
                      width: '200px',
                    }}
                  >
                    <DoughnutChartJS
                      showTitle={false}
                      showLegend={false}
                      labels={[
                        'Tổng số mã định danh xe (MAC/EVCC)',
                        'Tổng số khách hàng',
                      ]}
                      datasets={[
                        {
                          data: [
                            voucherPartnerReportData?.totalVehicles ?? 0,
                            voucherPartnerReportData?.totalDrivers ?? 0,
                          ],
                          borderColor: [
                            'rgba(255, 255, 255, 1)',
                            'rgba(255, 255, 255, 1)',
                          ],
                          backgroundColor: [
                            'rgba(41, 132, 238, 1)',
                            'rgba(249, 183, 0, 1)',
                          ],
                          borderWidth: 3,
                        },
                      ]}
                    />
                  </div>
                  <div className="flex-fill">
                    {UIHelper.buildDoughnutChartLegend([
                      {
                        title: 'Tổng số mã định danh xe (MAC/EVCC)',
                        color: 'rgba(41, 132, 238, 1)',
                        value: voucherPartnerReportData?.totalVehicles ?? 0,
                      },
                      {
                        title: 'Tổng số khách hàng',
                        color: 'rgba(249, 183, 0, 1)',
                        value: voucherPartnerReportData?.totalDrivers ?? 0,
                      },
                      {
                        title: 'Tổng số:',
                        value: _.sum(_.values([
                          voucherPartnerReportData?.totalVehicles ?? 0,
                          voucherPartnerReportData?.totalDrivers ?? 0
                        ])),
                      },
                    ])}
                  </div>
                </div>
              </div>,
              false,
              false,
              true,
              true
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default VoucherPartnerDashboardScreen;
